import { MutationTree } from 'vuex'
import { EndpointState } from '@/store/modules/endpoint/endpointTypes'

export const mutations: MutationTree<EndpointState> = {
  SAVE_ENDPOINTS(state, { endpoints, entityType }) {
    state.endpoints[entityType] = endpoints
  }
}
